import { MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit';
import React from 'react';
import GroupManager from './GroupUserManager';
import RoleManager from './RoleManager';

const RoleGroupManager = () => {
  return (
    <MDBContainer breakpoint="md" className='align-items-center justify-content-center'>
      <h2 className="text-center my-4">Roles and Groups</h2>

      <MDBRow >
        {/* Left Column - Role Manager */}
        <MDBCol md="6" className="p-3 border rounded shadow " >
          
            <RoleManager />
        
        </MDBCol>

        {/* Right Column - Group Manager */}
        <MDBCol md="6" className="p-3 border rounded shadow">
       
            <GroupManager />
       
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default RoleGroupManager;
